import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractNegotiation } from '../../../models/Entities/Contracts/ContractNegotiation';
import { ContractNegotiationVersion } from '../../../models/Entities/Contracts/ContractNegotiationVersion';
import { AppState } from '../../../redux/reducers';
import * as ContractNegotiationVersionStore from '../../../redux/middleware/ContractNegotiationVersionMiddleware';

export interface OwnProps {
  contractNegotiationId: string;
  contractId: number;
}

interface ConnectedProps {
  versions: ContractNegotiationVersion[];
  isLoading: boolean;
  errorMessage?: string;
}

interface DispatchProps {
  GetContractNegotiationVersions: typeof ContractNegotiationVersionStore.actionCreators.GetContractNegotiationVersions;
  CreateContractNegotiationVersion: typeof ContractNegotiationVersionStore.actionCreators.CreateContractNegotiationVersion;
  UpdateContractNegotiationVersion: typeof ContractNegotiationVersionStore.actionCreators.UpdateContractNegotiationVersion;
  DeleteContractNegotiationVersion: typeof ContractNegotiationVersionStore.actionCreators.DeleteContractNegotiationVersion;
}

export type Props = OwnProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedProps => {
  const contract: Contract | undefined =
    state.Contract?.list?.find((c: Contract) => c.id === ownProps.contractId);
  const negotiation: ContractNegotiation | undefined =
    contract?.negotiations?.find((n) => n.id === ownProps.contractNegotiationId);

  return {
    versions: negotiation?.versions || [],
    isLoading: negotiation?.isGettingNegotiationVersions || false,
    errorMessage: negotiation?.ErrorGettingNegotiationVersions?.ErrorMessage,
  };
};

export const mapDispatchToProps: DispatchProps = {
  GetContractNegotiationVersions: ContractNegotiationVersionStore.actionCreators.GetContractNegotiationVersions,
  CreateContractNegotiationVersion: ContractNegotiationVersionStore.actionCreators.CreateContractNegotiationVersion,
  UpdateContractNegotiationVersion: ContractNegotiationVersionStore.actionCreators.UpdateContractNegotiationVersion,
  DeleteContractNegotiationVersion: ContractNegotiationVersionStore.actionCreators.DeleteContractNegotiationVersion,
};
